export default __webpack_public_path__ + "static/media/On Screen Advertise.d8c0a7a0.jpg";